import * as Yup from 'yup';
import moment from 'moment';
import createExpressCheckin from './createExpressCheckingFormModel';
const {
  formField: {
    // DATOS AREA
    code,
    adults,
    minors,
    arrival,
    departure,
  },
} = createExpressCheckin;

export default [
  Yup.object().shape({
    [code.name]: Yup.string().required(`${code.requiredErrorMsg}`),
    [adults.name]: Yup.number().required(`${adults.requiredErrorMsg}`),
    [minors.name]: Yup.number().required(`${minors.requiredErrorMsg}`),

    [arrival.name]: Yup.string().required(`${arrival.requiredErrorMsg}`),
    [departure.name]: Yup.string()
      .required(`${departure.requiredErrorMsg}`)
      .test(
        'is-after-arrival',
        ({ path }) => `La fecha de salida debe ser posterior a la fecha de llegada`, // Mensaje dinámico
        function (value) {
          const arrivalDate = this.parent[arrival.name];
          if (!arrivalDate || !value) return true;

          // Usa timestamps para mayor precisión
          return new Date(value).getTime() > new Date(arrivalDate).getTime();
        }
      ),
  }),
];
